import { render, staticRenderFns } from "./WoundNotHealingAttachments.vue?vue&type=template&id=865ea34e&scoped=true&"
import script from "./WoundNotHealingAttachments.vue?vue&type=script&lang=js&"
export * from "./WoundNotHealingAttachments.vue?vue&type=script&lang=js&"
import style0 from "./WoundNotHealingAttachments.vue?vue&type=style&index=0&id=865ea34e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "865ea34e",
  null
  
)

export default component.exports